import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    merchants: [],
    selectedMerchant: null,
};

const merchantSlice = createSlice({
    name: 'merchant',
    initialState,
    reducers: {
        setMerchantList: (state, action) => {
            state.merchants = action.payload;
        },

        setSelectedMerchantID: (state, action) => {
            state.selectedMerchant = action.payload;
        },
    },
});

export const {
    setMerchantList,
    setSelectedMerchantID,
} = merchantSlice.actions;

export default merchantSlice.reducer;